import React, { useEffect, useMemo, memo } from "react"
import ControlPanel from "@/components/control-panel"
import { useSelector, useDispatch } from "react-redux"
import { useParams } from "react-router-dom"
import { getProjectByProjectIdRequest } from "@/redux/actions/projectAction"
import Loading from "@/components/common/Loading"
import RequestSnackbar from "@/components/common/RequestSnackbar"
import useHandleRequestSnackbar from "@/hooks/useHandleRequestSnackbar"
import ErrorAccess from "@/components/common/ErrorAccess"

const ProjectControlPanel = memo(() => {
    const { projectId } = useParams()
    const dispatch = useDispatch()
    const { loading, message, successStatus, projects, messagePopup, redirect } = useSelector((state) => state.projectReducer)

    useEffect(() => {
        const retrieveProjectDetail = async () => {
            dispatch(getProjectByProjectIdRequest(projectId))
        }
        retrieveProjectDetail()
    }, [projectId])

    const requestSnackbarValue = useHandleRequestSnackbar(messagePopup)

    // redirect when request popup close
    useEffect(() => {
        if (redirect && requestSnackbarValue.snackbarOpen && successStatus) {
            window.location.href = redirect
        }
    }, [redirect, requestSnackbarValue.snackbarOpen, successStatus])

    const output = useMemo(() => {
        if (!redirect && projects.length && projects[0].projectLaunchDate) {
            return <ErrorAccess message="Project has been completed" />
        }
        if (projects.length) {
            return <ControlPanel />
        }
        return <ErrorAccess errorComponent="ProjectControlPanel" />
    }, [projects, redirect])

    return (
        <>
            {loading ? (
                <Loading content="Loading Project Detail..." transformX={50} />
            ) : (
                <>
                    {output}
                    <RequestSnackbar
                        status={successStatus}
                        message={message}
                        snackbarOpen={requestSnackbarValue.snackbarOpen}
                        handleSnackbarOpenStatus={requestSnackbarValue.handleSnackbarOpenStatus}
                    />
                </>
            )}
        </>
    )
})

export default ProjectControlPanel
